import React, { useState, useEffect } from "react";
import { BlockFlipped, Add } from "@mui/icons-material";
import { Button, Paper, Typography, Box } from "@mui/material";
import { blockUser, followOrganization } from "../../services/UserProfileApi";

const Unknowndm = ({ receipientId, showSnackbar, isBlocked, isConnected, setShowMsg, setIsConnected, setIsBlocked }) => {
  const [blocked, setBlocked] = useState(isBlocked);
  const [loading, setLoading] = useState(false);

  // Sync if parent updates later
  useEffect(() => {
    setBlocked(isBlocked);
  }, [isBlocked]);

  const handleBlockToggle = async (id) => {
    try {
      setLoading(true);

      await blockUser(id);

      setBlocked(prev => !prev); // 🔥 THIS is the toggle
      showSnackbar(!blocked ? "User has been blocked." : "User has been unblocked.");
    } catch (error) {
      console.error("Block toggle error:", error);
      showSnackbar("Action failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

    const handleFollow = (id) => {
    followOrganization(id)
      .then((response) => {
        console.log("Follow request sent successfully:", response);
        showSnackbar(response.message || "Started following the organization.");
        if (setIsConnected) setIsConnected(true);
        if (setShowMsg) setShowMsg(false);
      })
      .catch((error) => {
        console.error("Error sending follow request:", error);
        showSnackbar("Failed to send follow request. Please try again.");
      });
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Typography variant="h6">You can’t send messages yet</Typography>

        <Typography variant="body2" color="text.secondary">
          You’re not following this organization.
        </Typography>



        <Box display="flex" gap={2}>
          <Button
            onClick={() => handleBlockToggle(receipientId)}
            startIcon={<BlockFlipped />}
            color={blocked ? "warning" : "error"}
            variant="outlined"
            disabled={loading}
            sx={{ textTransform: "none" }}
          >
            {blocked ? "Unblock" : "Block"}
          </Button>
          {!blocked && (
            <Button
              onClick={() => handleFollow(receipientId)}
              sx={{ textTransform: "none" }}
              startIcon={<Add />}
              variant="contained"
              disableElevation
            >
              Follow
            </Button>
          )}
        </Box>


      </Box>
    </Paper>
  );
};

export default Unknowndm;